import { FeatureCode } from '@recruitee/http/types';

export enum FeatureGuardMode {
  Dialog = 'dialog',
  Redirect = 'redirect',
}

export interface FeatureGuardComponent {
  mode: FeatureGuardMode;
  feature: string;
}

export enum GuardedFeature {
  AdjustableRoles = 'adjustableRoles',
  AdvancedReports = 'advancedReports',
  ReportsBuilderLaunch = 'reportsBuilderLaunch',
  ReportsBuilderScale = 'reportsBuilderScale',
  ReportsBuilderScaleVideo = 'reportsBuilderScaleVideo',
  ReportsBuilderLead = 'reportsBuilderLead',
  AutomatedActions = 'automatedActions',
  CustomDomain = 'customDomain',
  DefaultProfileFields = 'defaultProfileFields',
  EEO = 'EEO',
  EvaluationForms = 'evaluationForms',
  Multilang = 'multilang',
  OverdueCandidates = 'overdueCandidates',
  Pipelines = 'pipelines',
  Questionnaires = 'questionnaires',
  Referrals = 'referrals',
  SSO = 'sso',
  Scheduler = 'scheduler',
  OpenQuestions = 'openQuestions',
  SendLater = 'sendLater',
  SourcingExtension = 'sourcingExtension',
  Visibility = 'visibility',
  GDPRAutomations = 'gdprAutomations',
  Webhooks = 'webhooks',
  MeetingRooms = 'meetingRooms',
  JobScheduler = 'jobScheduler',
  ProfilePrint = 'profilePrint',
  Security = 'security',
  AuditLogs = 'auditLogs',
  FairEvaluations = 'fairEvaluations',
  NotificationsPerRole = 'notificationsPerRole',
  KnockoutQuestions = 'knockoutQuestions',
  Requisitions = 'requisitions',
}

export const legacyFeatureToCode: Partial<Record<GuardedFeature, FeatureCode>> = {
  [GuardedFeature.AdjustableRoles]: FeatureCode.AdjustableRoles,
  [GuardedFeature.AdvancedReports]: FeatureCode.AdvancedReports,
  [GuardedFeature.AuditLogs]: FeatureCode.AuditLogs,
  [GuardedFeature.AutomatedActions]: FeatureCode.AutomatedActions,
  [GuardedFeature.CustomDomain]: FeatureCode.CustomDomain,
  [GuardedFeature.DefaultProfileFields]: FeatureCode.DefaultProfileFields,
  [GuardedFeature.EEO]: FeatureCode.EEO,
  [GuardedFeature.EvaluationForms]: FeatureCode.EvaluationForms,
  [GuardedFeature.FairEvaluations]: FeatureCode.FairEvaluations,
  [GuardedFeature.GDPRAutomations]: FeatureCode.GDPRAutomations,
  [GuardedFeature.JobScheduler]: FeatureCode.JobScheduler,
  [GuardedFeature.KnockoutQuestions]: FeatureCode.KnockoutQuestions,
  [GuardedFeature.MeetingRooms]: FeatureCode.MeetingRooms,
  [GuardedFeature.Multilang]: FeatureCode.Multilang,
  [GuardedFeature.NotificationsPerRole]: FeatureCode.NotificationsPerRole,
  [GuardedFeature.OpenQuestions]: FeatureCode.OpenQuestions,
  [GuardedFeature.OverdueCandidates]: FeatureCode.OverdueCandidates,
  [GuardedFeature.Pipelines]: FeatureCode.Pipelines,
  [GuardedFeature.ProfilePrint]: FeatureCode.ProfilePrint,
  [GuardedFeature.Questionnaires]: FeatureCode.Questionnaires,
  [GuardedFeature.Referrals]: FeatureCode.Referrals,
  [GuardedFeature.ReportsBuilderLaunch]: FeatureCode.ReportsBuilderLaunch,
  [GuardedFeature.ReportsBuilderLead]: FeatureCode.ReportsBuilderLead,
  // [GuardedFeature.ReportsBuilderScaleVideo]: FeatureCode.ReportsBuilderScaleVideo, // ?
  [GuardedFeature.ReportsBuilderScale]: FeatureCode.ReportsBuilderScale,
  [GuardedFeature.Requisitions]: FeatureCode.Requisitions,
  [GuardedFeature.SSO]: FeatureCode.SSO,
  [GuardedFeature.Scheduler]: FeatureCode.Scheduler,
  [GuardedFeature.Security]: FeatureCode.Security,
  [GuardedFeature.SendLater]: FeatureCode.SendLater,
  [GuardedFeature.SourcingExtension]: FeatureCode.SourcingExtension,
  [GuardedFeature.Visibility]: FeatureCode.Visibility,
  [GuardedFeature.Webhooks]: FeatureCode.Webhooks,
};
